import React from "react";
import { About, Contact, Skills, Works, Experience, Blogs } from "./sections";
import { Footer, Navbar, SectionContainer } from "./tools";
import { Overlay } from "./sections/Overlay/index";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Fluid } from '@whatisjery/react-fluid-distortion';
import { EffectComposer } from '@react-three/postprocessing';
import { Canvas } from '@react-three/fiber';
import { useTheme } from "@/context/ThemeProvider";

export const Main = () => {
  const { theme } = useTheme();
  
  // Determine actual theme (resolve 'system' to 'dark' or 'light')
  const actualTheme = React.useMemo(() => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return theme;
  }, [theme]);

  // Theme-aware colors and settings
  const fluidSettings = {
    dark: {
      backgroundColor: '#070410',
      fluidColor: '#3300ff',
      intensity: 2.8,
      rainbow: true,
    },
    light: {
      backgroundColor: 'transparent',
      fluidColor: '#0066ff',
      intensity: 100,
      rainbow: false,
    }
  };

  const settings = fluidSettings[actualTheme as 'dark' | 'light'];

  return (
    <>
      {/* Fluid Distortion Background - Fixed Layer */}
      <Canvas
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
          zIndex: 0,
        }}
      >
        <EffectComposer>
          <Fluid
            intensity={settings.intensity}
            force={0.8}
            distortion={0.4}
            curl={1.9}
            swirl={4}
            radius={0.39}
            blend={5}
            showBackground={true}
            rainbow={settings.rainbow}
            pressure={0.8}
            densityDissipation={0.96}
            velocityDissipation={1.0}
            backgroundColor={settings.backgroundColor}
            fluidColor={settings.fluidColor}
          />
        </EffectComposer>
      </Canvas>

      {/* Main Content - Above the Canvas */}
      <main className="min-h-screen bg-transparent text-foreground mx-auto relative z-10" style={{ pointerEvents: 'auto' }}>
        <Router>
          <div className="flex min-h-screen flex-col w-[100%]">
            <Navbar />
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Overlay />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/experience" element={<Experience />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/portfolio" element={<Works />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </AnimatePresence>
            <Footer />
          </div>
        </Router>
      </main>
    </>
  );
}; 